import { Component, OnInit, ViewChild } from '@angular/core';
import { NzDrawerRef, NzMessageService } from 'ng-zorro-antd';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { Department } from '@app/_models/_DTOs/department';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetType } from '@app/_models/enums/assetType';
import { SupplierService } from '@app/_services/supplier.service';
import { AssetService } from '@app/_services';
import { LocationService } from '@app/_services/location.service';
import { DepartmentService } from '@app/_services/department.service';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { Location } from '@app/_models/_DTOs/location';
import { ITuple } from '@app/_models/tuple';
import { AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { Subject } from 'rxjs';
import { Sort } from '@app/_models/sort';
import { SortDirection } from '@app/_models/enums/sortDirection';
import { SupplierViewModel } from '@app/_models/_viewModels/supplier.viewmodel';

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.css']
})
export class SuppliersComponent implements OnInit {
  level: number = 0;
  
  sorts: Sort[] = [];
  pageIndex = 1;
  pageSize = 10;
  total = 1;
  supplierList: Supplier[] = [];
  loading = true;

  detailsDrawerVisible: boolean = false;
  editDrawerVisible: boolean = false;
  isSavingSupplier: boolean = false;
  isEditing: boolean = false;

  selectedSupplier: Supplier;
  supplierViewModel: SupplierViewModel = null;

  nameSearchValue = "";
  pinSearchValue = "";

  errorMessages = {};

  constructor(
    private supplierService: SupplierService,
    private messageService: NzMessageService
  ) {
  }

  ngOnInit() {
    this.searchData();
  }

  initModel(supplier?: Supplier) {
    if (supplier) {
      this.isEditing = true;
      this.supplierViewModel = {
        id: supplier.id ? supplier.id : -1,
        name: supplier.name ? supplier.name : "",
        pin: supplier.pin ? supplier.pin : undefined
      }
    }
    else {
      this.isEditing = false;
      this.supplierViewModel = {
        id: -1,
        name: "",
        pin: undefined
      }
    }
  }

  openCreateSupplierForm() {
    this.isEditing = false;
    this.initModel();
  }

  editSupplier(supplier: Supplier) {
    this.initModel(supplier);
  }

  deleteSupplier(id: number) {
    this.supplierService.delete(id).subscribe(result => {
      this.messageService.create("success", "Dobavljač uspješno obrisan");
      this.searchData();
    }, error => {
      console.log(error);
    });
  }

  sort(sort: { key: string; value: string }): void {
    var newSort: Sort = {
      PropertyName: sort.key,
      Direction: null
    };
    if (sort.value) {
      if (sort.value == "ascend") {
        newSort.Direction = SortDirection.Ascending;
      }
      else {
        newSort.Direction = SortDirection.Descending;
      }
    }

    if (newSort.Direction == null) {
      var existingSort = this.sorts.find(x => x.PropertyName == newSort.PropertyName);
      if (existingSort) {
        const index = this.sorts.indexOf(existingSort);
        if (index > -1) {
          this.sorts.splice(index, 1);
        }
      }
    }
    else {
      var existingSort = this.sorts.find(x => x.PropertyName == newSort.PropertyName);
      if (existingSort) {
        existingSort.Direction = newSort.Direction;
      }
      else {
        this.sorts.push(newSort);
      }
    }
    this.searchData();
  }

  getSortString() {
    var sortString = "";
    if (this.sorts && this.sorts.length > 0) {
      for(let sort of this.sorts){
        if(sort.Direction == SortDirection.Ascending){
          if(sortString.length == 0){
            sortString = sort.PropertyName;
          }
          else{
            sortString += "," + sort.PropertyName;
          }
        }
        else{
          if(sortString.length == 0){
            sortString = "-" + sort.PropertyName;
          }
          else{
            sortString += ",-" + sort.PropertyName;
          }
        }
      }
    }
    return sortString;
  }

  searchData(reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }

    var filters = "";
    if (this.nameSearchValue.length > 0) {
      filters += "Name@=" + this.nameSearchValue + ",";
    }
    if (this.pinSearchValue.length > 0) {
      filters += "SupplierOib@=" + this.pinSearchValue + ",";
    }

    var sortString = this.getSortString();
    if(sortString.length == 0){
      sortString = "-Created"
    }
    else{
      sortString += ",-Created"
    }

    this.loading = true;
    this.supplierService
      .getPage(this.pageIndex, this.pageSize, sortString, filters)
      .subscribe((data: ITuple<Supplier>) => {
        this.loading = false;
        this.total = data.item2;
        this.supplierList = data.item1;
      });
  }

  reset(): void {
    this.nameSearchValue = '';
    this.pinSearchValue = '';
    this.searchData(true);
  }

  openDetails(supplier: Supplier) {
    // this.supplierService
    //   .get(supplier.id)
    //   .subscribe((data: Supplier) => {
    //     this.selectedSupplier = data;
    //   });
  }

  closeDetails() {
    this.selectedSupplier = null;
  }

  closeEditDrawer(reload: boolean) {
    this.supplierViewModel = null;
    this.isEditing = false;
    if (reload) {
      this.searchData();
    }
  }

}
